import { Controller } from "@hotwired/stimulus"

// Collapses a block to a one-line summary. Generic — knows nothing about the
// domain. The summary mirrors a single designated input (summarySource).
// Smart default: a validation error always wins (expand); otherwise the caller's
// expanded value decides; otherwise fall back to "expand when the source is empty".
export default class extends Controller {
  static targets = ["details", "chevron", "summary", "summarySource"]
  static values = { emptyText: { type: String, default: "" }, expanded: Boolean }

  connect() {
    this.updateSummary()
    if (this.shouldStartExpanded()) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  toggle() {
    if (this.detailsTarget.classList.contains("hidden")) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  expand() {
    this.detailsTarget.classList.remove("hidden")
    this.chevronTarget.classList.add("rotate-180")
  }

  collapse() {
    this.detailsTarget.classList.add("hidden")
    this.chevronTarget.classList.remove("rotate-180")
  }

  updateSummary() {
    if (!this.hasSummaryTarget) return

    this.summaryTarget.textContent = this.sourceValue() || this.emptyTextValue
  }

  shouldStartExpanded() {
    if (this.element.querySelector(".error")) return true
    if (this.hasExpandedValue) return this.expandedValue

    return this.sourceValue() === ""
  }

  sourceValue() {
    return this.hasSummarySourceTarget ? this.summarySourceTarget.value.trim() : ""
  }
}
